import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../Zonas/ZonasListComponent.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTrash, faCalendar, faUsers } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import AsociadosDeLaLocalidadComponent from './AsociadosDeLaLocalidadComponent'
import Tooltip from '@mui/material/Tooltip';
import { useDispatch } from 'react-redux'
import { eliminarLocalidad } from '../../../redux/DucksUnidadInspeccion/ZonasDuck'
import SubLocalidadesDeLocalidadComponent from './SubLocalidadesDeLocalidadComponent'
import SublocalidadFormComponent from './SublocalidadFormComponent'
import InstalacionesComponent from './InstalacionesComponent'

library.add(faPen, faTrash, faCalendar, faUsers)

function SubLocalidadItemComponent(props) {

    const zona = props.zona
    const localidad = props.localidad
    const sublocalidad = props.sublocalidad
    const style = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1500, bgcolor: 'background.paper',
        border: '2px solid #000', boxShadow: 24, p: 4, overflow: 'scroll', height: '90%',
    };

    const styleAsociados = {
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 1200, bgcolor: 'background.paper',
        border: '2px solid #000', boxShadow: 24, p: 4, overflow: 'scroll', height: '90%',
    };

    const [modalverInstalaciones, setOpenVerInstalaciones] = React.useState(false);

    const handleAbrirModalverInstalaciones = () => setOpenVerInstalaciones(true);
    const handleCloseModalverInstalaciones = () => setOpenVerInstalaciones(false);

    const [openModalAsociados, setOpenModalAsociados] = React.useState(false);

    const handleOpenModalAsociados = () => {
        setOpenModalAsociados(true)
    };

    const handleCloseModalAsociados = () => {
        setOpenModalAsociados(false);
    }

    const HTMLmodalVerInstalaciones = () => {
        return (
            <Modal
                open={modalverInstalaciones}
                onClose={handleCloseModalverInstalaciones}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <InstalacionesComponent sublocalidad={sublocalidad} localidad={localidad} zona={zona}></InstalacionesComponent>
                </Box>
            </Modal >
        )
    }

    //ASOCIADOS
    const modalAsociados = () => {
        return (
            <div>
                <Modal
                    open={openModalAsociados}
                    onClose={handleCloseModalAsociados}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleAsociados}>
                        {/*<SubLocalidadesDeLocalidadComponent handleClose={props.handleClose} localidad={localidad} zona={zona} />*/}
                        <AsociadosDeLaLocalidadComponent localidad={localidad} sublocalidad={sublocalidad} zona={zona} handleCloseModalAsociados={handleCloseModalAsociados}></AsociadosDeLaLocalidadComponent>
                    </Box>
                </Modal>
            </div>
        )
    }


    return (
        <Fragment>
            <div className={`alert alert-secondary ${estilos.alertItem}`} role="alert" id='index' >
                <div className='row'>
                    <div className='col-md-1 mt-4' style={{ paddingLeft: '7%', position: 'absolute' }}>
                        <div style={{ width: '20px', height: '20px', backgroundColor: sublocalidad.pin, borderRadius: '50%' }}>

                        </div>
                    </div>
                    <div className='col-md-6 mt-3' style={{ paddingLeft: '15%' }}>
                        <h5><strong>{sublocalidad.nombresublocalidad}</strong></h5>
                        <p></p>
                    </div>
                    <div className='col-md-4' style={{ fontSize: '30px', textAlign: 'left' }}>

                        <Tooltip title="Editar sublocalidad">
                            <button onClick={() => props.handleEditarSubLocalidad(sublocalidad)} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon icon={faPen} /></button>
                        </Tooltip>
                        {/* <Tooltip title="Borrar sublocalidad">
                            <button onClick={() => props.handleBorrarSubLocalidad(sublocalidad)} className={`${estilos.botonItemZona} 
                            ${estilos.zoom2} text-wrap text-center`}><FontAwesomeIcon icon={faTrash} /></button>
                        </Tooltip> */}

                        <Tooltip title="Ver Asociados">
                            <button onClick={() => handleOpenModalAsociados()} className={`${estilos.botonItemZona} ${estilos.zoom2} text-wrap text-center`} ><FontAwesomeIcon icon={faUsers} /></button>
                        </Tooltip>

                    </div>
                </div>
            </div>
            <br />
            {HTMLmodalVerInstalaciones()}
            {modalAsociados()}
        </Fragment>
    );
};


export default withRouter(SubLocalidadItemComponent)
